{
  "collect": "Kumpul Spesimen",
  "track": "Jejak Spesimen",
  "accession": "Nombor Aksesyen",
  "barcode": "Kod Bar",
  "status": {
    "ordered": "Dipesan",
    "collected": "Dikumpul",
    "inTransit": "Dalam Penghantaran",
    "received": "Diterima",
    "processing": "Sedang Diproses",
    "resulted": "Keputusan Tersedia",
    "rejected": "Rejected",
    "in_transit": "Dalam Penghantaran"
  },
  "title": "Specimens",
  "loading": "Loading specimens…",
  "errorState": "Could not load specimens.",
  "emptyState": "No specimens for this patient.",
  "noRejectionReason": "Rejected — no reason recorded",
  "columns": {
    "accession": "Accession",
    "type": "Type",
    "status": "Status",
    "collected": "Collected",
    "received": "Received",
    "location": "Location"
  }
}
